import { createSlice } from "@reduxjs/toolkit";

const flopSlice = createSlice({
  name: "flop",
  initialState: {
    result: [],
    turnResult: [],
    colors: "",
    inputValues: {
      pl1: "",
      pl2: "",
      pl3: "",
      pl4: "",
    },
    inputString: "",
    cards: {
      turn1: {},
      turn2: {},
      turn3: {},
      turn4: {},
      turn5: {},
    },
    disable: false,
    allow: false,
    RangeAnalysis: [],
  },
  reducers: {
    setFlopResult: (state, { payload }) => {
      state.result = payload?.result;
      state.colors = payload?.colors;
    },
    setInputValues: (state, { payload }) => {
      state.inputValues = payload?.values;
      state.inputString = payload?.payload;
    },
    setCards: (state, { payload }) => {
      state.cards = payload;
    },
    allowTurn: (state, { payload }) => {
      state.allow = true;
    },
    disableCalculateButton: (state, { payload }) => {
      state.disable = true;
    },
    resetFlop: (state, { payload }) => {
      state.disable = false;
      state.cards = {
        turn1: {},
        turn2: {},
        turn3: {},
        turn4: {},
        turn5: {},
      };
      state.inputValues = {
        pl1: "",
        pl2: "",
        pl3: "",
        pl4: "",
      };
      state.inputString = "";
      state.result = [];
      state.colors = [];
      state.RangeAnalysis = [];
    },
    setRangeAnalysisResult: (state, { payload }) => {
      state.RangeAnalysis = payload;
    },
  },
});
export const {
  setFlopResult,
  setInputValues,
  setCards,
  disableCalculateButton,
  resetFlop,
  allowTurn,
  setRangeAnalysisResult,
} = flopSlice.actions;
export default flopSlice.reducer;
